(function(){
  function init(root){
    if(root.dataset.htaInit)return;root.dataset.htaInit='1';
    var d=root.querySelector('[data-hta-date]');
    if(d&&!d.textContent.trim())d.textContent=new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'});
    var bar=root.querySelector('[data-hta-countdown]');
    if(bar){
      var end=new Date((bar.getAttribute('data-end')||'').replace(' ','T'));
      var cells=bar.querySelectorAll('.hta-cd span');
      var tick=function(){
        var s=Math.floor((end-new Date())/1000);
        if(isNaN(s)||s<=0){bar.style.display='none';return false}
        var v=[Math.floor(s/86400),Math.floor(s%86400/3600),Math.floor(s%3600/60),s%60],u=['d','h','m','s'];
        for(var i=0;i<4;i++)cells[i].textContent=String(v[i]).padStart(2,'0')+u[i];
        return true;
      };
      if(tick())var iv=setInterval(function(){if(!tick())clearInterval(iv)},1000);
    }
    var st=root.querySelector('[data-hta-sticky]'),offer=root.querySelector('[data-hta-offer]');
    if(st){
      var inOffer=false;
      var upd=function(){st.classList.toggle('show',window.scrollY>500&&!inOffer)};
      if(offer&&'IntersectionObserver'in window)new IntersectionObserver(function(e){inOffer=e[0].isIntersecting;upd()}).observe(offer);
      window.addEventListener('scroll',upd,{passive:true});upd();
    }
  }
  function all(){document.querySelectorAll('[data-hta]').forEach(init)}
  if(document.readyState!=='loading')all();else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('[data-hta]');if(r)init(r)});
})();
